import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Vendor } from './vendor.model';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
@Injectable({
    providedIn: 'root',
})
export class VendorService {
    private apiUrl: string;

    constructor(private http: HttpClient, private store: Store<State>) {
        this.store.select(environmentSelector).subscribe((env) => {
            if (env && env.baseUrl) {
                this.apiUrl = `${env.baseUrl}/market/admin/vendor`;
            }
        });
    }

    getVendors(): Observable<Vendor[]> {
        return this.http.get<Vendor[]>(`${this.apiUrl}`);
    }

    getVendor(id: string): Observable<Vendor> {
        return this.http.get<Vendor>(`${this.apiUrl}/${id}`);
    }

    addVendor(vendor: Vendor): Observable<Vendor> {
        return this.http.post<Vendor>(`${this.apiUrl}`, vendor);
    }

    updateVendor(id: string, vendor: Vendor): Observable<Vendor> {
        return this.http.put<Vendor>(`${this.apiUrl}/${id}`, vendor);
    }

    deleteVendor(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }

    importVendorsFromCsv(fileName: string, fileContent: string): Observable<any> {
        const body = JSON.stringify({ fileName, fileContent });

        return this.http.post(`${this.apiUrl}/upload-csv`, body, {
            headers: { 'Content-Type': 'application/json' },
        });
    }
}
